<template>
  <b-card>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="loadingState"
    >
      <b-row>
        <b-col md="6">
          <zones-list
            @zones-loading-state="loadingState = $event"
            @zone-selected="onZoneSelected"
          />
        </b-col>
        <b-col md="12">
          <b-button
            variant="primary"
            :disabled="!zone"
            @click="handleAddVersion"
          >
            Next
          </b-button>
        </b-col>
      </b-row>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BOverlay, BCard, BButton, BRow, BCol,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import ZonesList from '../components/ZonesList.vue'
// import ServicesList from '../components/ServicesList.vue'

export default {
  components: {
    ZonesList,
    BRow,
    BCol,
    BOverlay,
    BCard,
    BButton,
  },
  setup(props, ctx) {
    const loadingState = ref(true)
    const zone = ref(null)
    const onZoneSelected = event => {
      zone.value = event
    }

    const handleAddVersion = () => {
      ctx.root.$router.push({
        path: '/versions/new',
        query: {
          zone: zone.value,
        },
      })
    }

    return {
      loadingState,
      zone,
      handleAddVersion,
      onZoneSelected,
    }
  },
}
</script>

    <style>

    </style>
